import PropTypes from 'prop-types';
import './styles.css';

const TallyInlineGroup = ({ children }) => {
  return <div className="tally-inline-group">{children}</div>;
};

TallyInlineGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TallyInlineGroup;
